import { C } from "../../lib/colors";

export const IllustrationContent = () => (
  <svg viewBox="0 0 320 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",height:"100%"}}>
    <rect width="320" height="200" rx="16" fill="#0C0F1A"/>
    <rect x="16" y="16" width="180" height="168" rx="10" fill="#111520" stroke="rgba(255,255,255,0.07)" strokeWidth="1"/>
    <rect x="28" y="28" width="120" height="8" rx="3" fill={C.amber} opacity="0.7"/>
    <rect x="28" y="44" width="150" height="4" rx="2" fill="rgba(255,255,255,0.08)"/>
    <rect x="28" y="52" width="140" height="4" rx="2" fill="rgba(255,255,255,0.06)"/>
    <rect x="28" y="60" width="155" height="4" rx="2" fill="rgba(255,255,255,0.07)"/>
    <rect x="28" y="76" width="100" height="6" rx="2" fill="rgba(255,176,48,0.4)"/>
    <rect x="28" y="90" width="150" height="4" rx="2" fill="rgba(255,255,255,0.06)"/>
    <rect x="28" y="98" width="130" height="4" rx="2" fill="rgba(255,255,255,0.07)"/>
    <rect x="28" y="106" width="145" height="4" rx="2" fill="rgba(255,255,255,0.05)"/>
    <rect x="28" y="120" width="100" height="6" rx="2" fill="rgba(255,176,48,0.4)"/>
    <rect x="28" y="134" width="150" height="4" rx="2" fill="rgba(255,255,255,0.06)"/>
    <rect x="28" y="142" width="120" height="4" rx="2" fill="rgba(255,255,255,0.07)"/>
    <rect x="28" y="158" width="80" height="16" rx="5" fill="rgba(0,240,160,0.15)" stroke={C.green} strokeWidth="1"/>
    <text x="68" y="170" textAnchor="middle" fontSize="7" fill={C.green} fontFamily="monospace">PUBLISH →</text>
    <rect x="208" y="16" width="96" height="80" rx="10" fill="#111520" stroke="rgba(255,255,255,0.07)" strokeWidth="1"/>
    <text x="256" y="38" textAnchor="middle" fontSize="9" fill="rgba(255,255,255,0.3)" fontFamily="monospace">SEO SCORE</text>
    {[{l:"Read",v:82,c:C.green},{l:"SEO",v:91,c:C.blue},{l:"Engage",v:74,c:C.amber}].map((s,i)=>(
      <g key={i}>
        <text x="216" y={54+i*16} fontSize="7" fill="rgba(255,255,255,0.3)" fontFamily="monospace">{s.l}</text>
        <rect x="248" y={47+i*16} width="46" height="5" rx="2.5" fill="rgba(255,255,255,0.06)"/>
        <rect x="248" y={47+i*16} width={46*s.v/100} height="5" rx="2.5" fill={s.c} opacity="0.8"/>
        <text x="298" y={54+i*16} fontSize="7" fill={s.c} fontFamily="monospace">{s.v}</text>
      </g>
    ))}
    <rect x="208" y="108" width="96" height="76" rx="10" fill="#111520" stroke="rgba(255,255,255,0.07)" strokeWidth="1"/>
    <text x="256" y="126" textAnchor="middle" fontSize="9" fill="rgba(255,255,255,0.3)" fontFamily="monospace">KEYWORDS</text>
    {["local SEO","content","plumber"].map((kw,i)=>(
      <rect key={i} x={216+(i%2)*46} y={132+Math.floor(i/2)*18} width={38+(i===2?8:0)} height="13" rx="6"
        fill="rgba(0,240,160,0.1)" stroke="rgba(0,240,160,0.25)" strokeWidth="1"/>
    ))}
    {["local SEO","content","plumber"].map((kw,i)=>(
      <text key={i} x={235+(i%2)*46} y={142+Math.floor(i/2)*18} textAnchor="middle" fontSize="6" fill={C.green} fontFamily="monospace">{kw}</text>
    ))}
  </svg>
);
